import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'bb-message',
	templateUrl: './bb-message.component.html',
	styleUrls: ['./bb-message.component.scss']
})

export class BbMessageComponent implements OnInit {
	@Input() type: 'message' | 'info' | 'warning' | 'error' | 'success' = 'message';

	icon = {
		message: 'info',
		info: 'info',
		warning: 'warning',
		error: 'warning',
		success: 'check'
	};

	constructor() { }

	ngOnInit() {

	}
}
